
import StyleClassNamesBuilder from '@/ui-kit/styles/helpers/StyleClassNamesBuilder';
import Button from '@/ui-kit/components/button';
import Typography from '@/ui-kit/components/typography';
import { TypographyType, TypographyProperty } from '@/ui-kit/components/typography/enums';
import { ImageProperty } from '@/ui-kit/components/image/enums';
import BaseImage from '@/ui-kit/components/image';
import { ButtonProperty, ButtonPropsEventType } from '@/ui-kit/components/button/enums';
import { StyleColorSchemeType, StyleFontWeightType } from '@/ui-kit/styles/enums';
import { ListingNavigationCardVariant } from './enums';
import ListingNavigationCardProps from './mixins/ListingNavigationCardProps';
import { track } from '@/utils/analytics';

export default {
  name: 'ListingNavigationCard',
  components: {
    Button,
    BaseImage,
    Typography,
  },
  mixins: [ListingNavigationCardProps],
  data() {
    return {
      ImageProperty,
      ButtonProperty,
      ButtonPropsEventType,
      TypographyType,
      TypographyProperty,
      StyleColorSchemeType,
      StyleFontWeightType,
    };
  },
  computed: {
    className() {
      return new StyleClassNamesBuilder('listing-navigation-card')
        .addConditionClassNames(Object.values(ListingNavigationCardVariant), this.variant)
        .build();
    },
  },
  methods: {
    trackNavigationCardButtonClick() {
      const { listingId } = this.$route.query;

      track(`${this.origin}_Sold Property_${this.buttonName} button click`, {
        listingId,
        listingType: this.origin,
      });
    },
  },
};
